import sanityClient from "@sanity/client";

export default sanityClient({
    projectId: "5umjsl3w",
    dataset: "production",
    useCdn: true,
    apiVersion: '2022-02-14'
})